import React from "react";

const Container: React.FC<
  React.PropsWithChildren<{
    onClick?: () => void;
    variant?: "store" | "cart";
  }>
> = ({ children, onClick, variant = "store" }) => (
  <header
    onClick={onClick}
    data-testid={`${variant}-header`}
    className={`fixed z-[1000] w-full bg-blue shadow-[0_4px_5px_-1px_rgba(0,0,0,0.2)] md:left-0 md:right-0 ${variant === "store" ? "md:h-auto md:bg-white" : ""} ${variant === "cart" ? "flex h-[49px] items-center pt-[3px] md:h-[66px] md:pt-0" : ""}`}
  >
    <div
      className={`flex w-full flex-wrap items-center gap-x-2 gap-y-3 px-3 py-3 md:mx-auto md:w-[100%] md:max-w-[1070px] md:items-start md:gap-x-[0.625rem] md:gap-y-1.5 md:pb-0 md:pt-0 lg:px-0 ${variant === "store" ? "md:mt-[1.6rem]" : ""} ${variant === "cart" ? "pr-[3.3125rem] xsm:pr-3" : ""}`}
    >
      {children}
    </div>
  </header>
);

export default Container;
